/* eslint complexity: [1, 12] */
import VALIDATION_REGEX from '../validation-regex';

/**
 * Checks validity of radio group.
 * @param  {DOMElement} item section container;
 * @return {boolean}
 */
function inputCheck(item, item_type, is_required) {
  const input_elems = item.getElementsByTagName('input');
  let has_value = false;
  let dropdown_errors = 0;

  // if not required return true since we only check if any value exists
  if (!is_required) {
    return true;
  }

  // loop through all inputs and return true if at least one has a value
  for (let i = 0; i < input_elems.length; i++) {
    // if radio check checked attribute
    if (item_type === 'radio') {
      if (input_elems[i].checked) {
        has_value = true;
      }
    } else {
      let value = input_elems[i].value;

      // all date dropdowns have 0 value for first default element, it should be different than default
      if (!(value && value !== '0')) {
        console.log('value is', value);
        dropdown_errors++;
      }
    }
  }

  // All 3 dropdowns need to be selected in order for the date to be valid
  if (item_type !== 'radio' && dropdown_errors === 0) {
    has_value = true;
  }

  return has_value;
}


/**
 * Checks if input matches given regex type.
 * @param  {[type]}  item        [description]
 * @param  {Boolean} is_required [description]
 * @return {[type]}              [description]
 */
function inputMatch(item, regex_type, is_required) {
  const input = item.getElementsByTagName('input')[0];
  const value = input.value;

  // if it's not required and there is no value there is a match
  if (!is_required && !value) {
    return true;
  }

  // if given regex type exists in the constant run a match and return boolean
  if (VALIDATION_REGEX[regex_type]) {
    let regex = VALIDATION_REGEX[regex_type];

    return !!value.match(regex);
  } else {
    // console warning message in case there is no appropriate regex_type defined
    // important to resolve bugs quickly
    console.warn(`Regural expression type named: "${regex_type}" doesn't seem to exist`);
  }

  // return true by default
  return true;
}

export { inputCheck, inputMatch };
